<template>
    <v-layout row>
        <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
            <v-card>
                <v-card-title>
                    Log into MyDocPort
                </v-card-title>
                <v-card-text>
                    Please log in to use MyDocPort
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import { getInstance } from '@/auth/authWrapper'
import router from '@/router'

export default {
    name: 'Login',
    data: () => ({}),
    async created() {
        const authService = getInstance()
        // If the user is authenticated
        if (authService.isAuthenticated) {
            // Get user info
            await authService.getMe()
            const userRole = authService.getUserForPortalAccess().user_type

            // Redirect to corresponding home
            const home = userRole === 'admin' ? 'dashboard' : 'splash'
            const { href } = router.resolve({ name: home })

            window.location.href = href
        }
    },
    methods: {
        login() {
            this.$auth.loginWithRedirect()
        },
    },
}
</script>
